import React, { Component } from 'react';
import { getOrderCountReq, updResetTimeReq } from '../config/httpRoutes';
import { alertError } from '../config/toast';
import { OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import Loader from '../components/loader';
import { faBusinessTime } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class OrderCounts extends Component {
	state = {
		orderCounts: null,

		fetchLoading: false,
		loading: false
	};

	componentDidMount() {
		this.getOrderCounts();
	}

	getOrderCounts = () => {
		this.setState({fetchLoading: true});
		getOrderCountReq()
		.then( (res) => {
			this.setState({orderCounts: res.data, orders: res.data});
		}).catch( (err) => {
			alertError(err.response?.data?.msg || "Could not fetch orders");
		}).finally( () => {
			this.setState({fetchLoading: false});
		});
	}

	handleChange = ({ target: { name, value } }) => {
		this.setState({[name]: value});
	}

	resetTimer = (seller) => {
		updResetTimeReq({seller, timestamp: Date.now()})
		.then( (res) => {
			this.getOrderCounts();
		}).catch( (err) => {
			alertError(err.response?.data?.msg || "Could not update reset time");
		});
	}

	render() {
		const { orderCounts, fetchLoading, loading } = this.state;
		const { resetTimer } = this;
		return (
			<Row style={{marginLeft: 0, marginRight: 0, paddingLeft: '10%', paddingRight: '10%', paddingTop: '5%'}}>
				{fetchLoading && <Loader />}
				{Array.isArray(orderCounts) ?
					orderCounts.length > 0 ?
						<div className="table-responsive">
							<table className="table table-hover table-attendance">
								<thead>
									<tr>
										<th>Seller Phone</th>
										<th>Seller Company Name</th>
										<th>Seller Name</th>
										<th>Total Delivered Orders</th>
										<th>Total Declined Orders</th>
										<th>Total Order Amount</th>
										<th className="th1">Action</th>
									</tr>
								</thead>
								<tbody>
									{orderCounts.map(({ id, name, company, phone, delivered, declined }, i) =>
										<tr key={i}>
											<td>{phone}</td>
											<td>{company}</td>
											<td>{name}</td>
											<td>{delivered?.total_number || ''}</td>
											<td>{declined?.total_number || ''}</td>
											<td>{delivered?.total_amount || ''}</td>
											<td className="text-center">
												<div className="course-control-box icons-container d-flex">
													<OverlayTrigger overlay={<Tooltip>Reset Seller Timer</Tooltip>} delay={{ show: 150, hide: 150 }} >
														<FontAwesomeIcon icon={faBusinessTime} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { resetTimer(id) }} />
													</OverlayTrigger>
												</div>
											</td>
										</tr>
									)}
								</tbody>
							</table>
						</div>
					:
						<p style={{position: 'fixed', marginLeft: '34%', marginTop: '20%'}}>No sellers found.</p>
				:
					<></>
				}
			</Row>
		);
	}
}

export default OrderCounts;